<template>
    <v-container>
        <v-row>
            <v-img :src="require('@/assets/gifiqr-nyheder.jpg')"/>
        </v-row>
        <v-row>
            <v-col md="8" align="left">
                <v-row v-for="(n, i) in news" :key="i">
                    <v-col align="left">
                        <h1>{{ n.title }}</h1>
                        <div class="font-weight-thin">{{ n.date }}</div>
                        <v-card flat v-if="n.titleimg">
                            <v-img :src="n.titleimg"/>
                        </v-card>
                        <p v-for="(t, ii) in n.texts" :key="ii">
                            {{ t }}
                        </p>
                        <v-card flat v-for="(img, iii) in n.imgs" :key="iii">
                            <v-img :src="img.path" :max-width="img.mw" :aspect-ratio="img.ar"/>
                        </v-card>
                        <v-divider class="my-5"/>
                    </v-col>
                </v-row>
            </v-col>
            <v-col md="4" align="left">
                <ContactForm :know-more="true"/>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import ContactForm from "@/components/ContactForm";
    export default {
        name: "NewsPage",
        components: {ContactForm},
        data: () => ({
            news: [
                {
                    title: 'Cramo Adapteo er ny kunde på gofiqr',
                    titleimg: null,
                    date: '2017-03-17',
                    texts: [
                        'Vi har netop indledt samarbejde med Cramo Adapteo omkring digitalisering af produktinformation og betjeningsvejledninger omkring Cramo Adapteo´s state-of-the-art pavillonmoduler.',
                        'Første milepæl er styrket kommunikation med byggeledere, projektrådgivere, skole-/institutionsspecialister og andre interessenter.',
                        'Næste milepæl er at effektivisere adgangen til brugerinformation omkring mandskabs- og beboelsesenheder, plejeboliger,  kontorpavilloner og midlertidige lokaler til skoler og institutioner.',
                    ],
                    imgs: [
                        {path: require('@/assets/cramo01.png'), mw: 300, ar: 1},
                        {path: require('@/assets/cramo02.png'), mw: 300, ar: 1},
                        {path: require('@/assets/cramo03.png')},
                    ],
                },
                {
                    title: 'Savner du overblik på hylderne?',
                    titleimg: require('@/assets/savner-du01.jpeg'),
                    date: '2017-02-28',
                    texts: [
                        'Så er du ikke den eneste. I produktionsvirksomheden J E Juncker, som leverer ståldæksler og riste til kommuner og forsyningsselskaber, har vi hos gofiqr netop hjulpet organisationen i gang med en større forårsrengøring og givet dem redskabet til at identificere og registrere alle produkter i virksomhedens varelager.',
                        'Processen er ganske enkel: Med gofiqrs QR kode på alle produkter og varerne registreret i gofiqr-universet er det nu blevet nemt for alle ansatte i virksomheden at scanne varerne med mobiltelefonen og hurtigt få de relevante vareinformationer, tegninger og kundedata på produktet.',
                        'gofiqr-løsningen er dermed første vigtige skridt i J E Junckers omstillingsproces fra traditionel lidt tung produktionsvirksomhed, med et stort og uoverskueligt varelager, til en moderne, mere omstillingsparat og kundefokuseret virksomhed, der har et mindre, overskueligt og altid anvendeligt lager af produkter.',
                        'Hos gofiqr elsker vi at hjælpe virksomheder til at blive mere velfungerende og strømlinede. Sig til, hvis vi også må hjælpe dig.',
                    ],
                    imgs: [],
                },
                {
                    title: 'Flygtninge fortjener vel også lidt hjælp på vejen',
                    titleimg: require('@/assets/flygtninge01.jpeg'),
                    date: '2017-02-24',
                    texts: [
                        'Ingen tvivl om, at det er en god idé, at flygtninge og andre tilkomne borgere i Danmark lærer dansk, når de skal tilegne sig og bestride et job. Og ingen tvivl om, at det er noget af en mundfuld for langt de fleste og også ville være det for alle  os andre, hvis vi var i deres sted. Derfor har vi hos gofiqr valgt at undersøge, om vi ikke kan hjælpe "bjerget lidt tættere på Muhammed" - om man så må sige:',
                        'I samarbejde med en række kommuner undersøger vi i øjeblikket, hvordan gofiqrs QR-univers kan hjælpe flygtninge og andre ikke-dansk-talende, der tager en uddannelse, som fx buschauffør eller håndværker, i alle de regler og processer de skal lære. Via QR-koder og scanning på mobiltelefonen får personerne ikke kun let adgang til vejledningerne på dansk - men altså også til versioner af materialet, der matcher deres sproglige baggrund. Hos gofiqr mener vi nemlig, at "understøttende undervisning" sagtens kan anvendes andre steder end i folkeskolen, og at både indlæring og tilegnelsen af det danske sprog kan styrkes betragteligt på denne måde.',
                        'Vi glæder os meget til at udvikle samarbejdet med kommunerne og se gofiqr blive anvendt også uden for vores almindelige marked, erhvervslivet.',
                    ],
                    imgs: [],
                },
                {
                    title: 'Kender du det, at du kommer i tvivl...?',
                    titleimg: require('@/assets/kenderdudet01.jpeg'),
                    date: '2017-01-02',
                    texts: [
                        'Når dagen bare bliver for presset, når kollegerne er syge, og du skal tage over, eller når det bare er lidt for lang tid siden, du sidst har betjent netop denne maskine?',
                        'Så er du ikke spor anderledes end alle os andre. Den gode nyhed er dog, at hjælpen er nær. Og at det ikke er spor svært at række ud og fjerne tvivlen for altid.',
                        'Med gofiqr-universet på din arbejdsplads gør du nemlig både dit eget og dine kollegers liv meget lettere. Scan QR-koden og bliv klædt på til din arbejdsdag. Også når boldene flyver om ørerne på jer. Og når sygdom og uvante opgaver truer.',
                        'QR-koder og gofiqr-universet hjælper allerede mange virksomheder og organisationer til en lettere og mere effektiv hverdag. Må vi også hjælpe dig? Så ring på tlf. 2222 3701.',
                    ],
                    imgs: [],
                },
                {
                    title: 'Sådan får du en reklamefri QR-scanner',
                    titleimg: require('@/assets/reklamefriqrs01.jpeg'),
                    date: '2016-12-22',
                    texts: [
                        'Var du med i den første bølge af begejstrede QR-brugere i midt-90\'erne, så har du lige så sikkert også oplevet irritationen ved, at de QR-koder, du har scannet, har medført uønskede reklamer eller andet spam som sidegevinst.',
                        'Og skal sandheden frem, så ER det fortsat et problem for langt de fleste QR-scannere. Hos os bag gofiqr-løsningen er vi derfor i gang med at udvikle vores egen garanteret reklamefri scanner specielt til dig, der bruger vores løsning. Før den kommer på banen henviser vi her til de scannere, som vi pt. anser for at være de mest sikre og altså også "reklamesikre". De koster et par håndører - men vores klare anbefaling er - gør det alligevel og undgå irritationen.',
                        'Download din sikre version her: iOS , Android, Windows',
                    ],
                    imgs: [],
                },
            ],
        }),
    }
</script>

<style scoped>
    .date {
        color: rgba();
    }
</style>